import { IPaymentCardCreateInitiateResponse } from "@wingspanhq/payments/dist/interfaces";
import { paymentsService } from "../../../services/payments";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";

export const useMutationInitiatePaymentCardCreate = () =>
  useWSMutation<IPaymentCardCreateInitiateResponse, WSServiceError>(
    paymentsService.paymentCard.initiateCreate
  );
